/**
 * 서비스 워커 등록과 **API 캐시 비우기**.
 *
 * 등록은 프로덕션 빌드에서만 한다 — 개발 중에 워커가 낡은 번들을 물고 있으면
 * 원인을 찾기 어려운 버그가 된다(Next 판 `sw-register.tsx`도 같은 판단).
 *
 * `purgeApiCache()`는 **사용자가 바뀔 때** 부른다. 서비스 워커가 `GET /api/*`
 * 응답을 캐시하므로, 공용 기기에서 그대로 두면 앞사람 여행이 다음 사람에게
 * 보인다. 부르는 곳은 두 군데다: 로그인 직후 신원 확인(session-gate.tsx)과
 * 로그아웃(main.tsx의 ClerkProvider).
 */
const SW_URL = "/sw.js";

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!("serviceWorker" in navigator)) return;
  // 등록 실패는 조용히 넘긴다 — PWA는 부가 기능이고, 여기서 던지면 앱이 안 뜬다.
  navigator.serviceWorker.register(SW_URL).catch(() => {});
}

/**
 * 워커에게 API 캐시를 지우라고 시킨다.
 *
 * 워커가 아직 없거나(첫 방문) 등록 전이면 조용히 지나간다 — 지울 캐시도 없다.
 * `ready`를 기다리는 이유는 `controller`가 첫 로드에서 null일 수 있어서다.
 */
export async function purgeApiCache(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    (reg?.active ?? navigator.serviceWorker.controller)?.postMessage({ type: "PURGE_API" });
  } catch {
    // 지우지 못해도 앱은 돌아야 한다.
  }
}
